import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { IssuesArchiveEffects } from './archive/archive.effects';
import { IssuesAnalyticsEffects } from './issues-analytics.effects';
import { IssuesBroadcastsEffects } from './issues-broadcasts.effects';
import { IssuesRocksEffects } from './issues-rocks.effects';
import { IssuesSubscriptionsEffects } from './issues-subscriptions.effects';
import { IssuesEffects } from './issues.effects';
import { ISSUES_V2_STATE_KEY } from './issues.model';
import { issuesStateReducer } from './issues.reducer';
import { IssuesTrashEffects } from './trash/trash.effects';

/**
 * Eager issues-v2 NgRx registration so shared layout (filters-toolbar) can select
 * issues state before the lazy issues route loads. Mirrors RockStateModule.
 */
@NgModule({
  imports: [
    StoreModule.forFeature(ISSUES_V2_STATE_KEY, issuesStateReducer),
    EffectsModule.forFeature([
      IssuesEffects,
      IssuesAnalyticsEffects,
      IssuesBroadcastsEffects,
      IssuesSubscriptionsEffects,
      IssuesRocksEffects,
      IssuesTrashEffects,
      IssuesArchiveEffects,
    ]),
  ],
})
export class IssuesV2StateModule {}
